import React, { useEffect } from 'react';
import { Routes } from 'utils/routes';
import { useRouter } from 'next/router';

const DictionaryEntryList = ({ dictionaryEntries }) => {
    const router = useRouter();

    return <article className="dictionaryEntryList">
        <ul>
            {
                dictionaryEntries && dictionaryEntries.map((listEntry) => (
                    <li key={ listEntry.letter }>
                        <div id={ listEntry.letter } >{ listEntry.letter }</div>
                        <ol>
                            {
                                listEntry.entries && listEntry.entries.map((entry) => (
                                    <li key={ entry.title }><a onClick={ () => router.push( Routes.Dictionary.Entry(entry.slug)) }>{ entry.title }</a></li>
                                ))
                            }
                        </ol>
                    </li>
                ))
            }
        </ul>
    </article>;
};

DictionaryEntryList.defaultProps = {};

DictionaryEntryList.propTypes = {};

export default DictionaryEntryList;
